import React, { useEffect } from "react";
import SignaturePad from "react-signature-canvas";
import { Typography, Divider, Box, Button } from "@mui/material";
import { Block, Save } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../../../store/actions";
import { RootState } from "../../../../store/types";
import { LoadingButton } from "@mui/lab";
import { IUpdateServiceDraftBody } from "./Checklist";

interface Props {
  onClose: CallableFunction;
  isOpen: boolean;
  createOrUpdateDraft: (signatureIds: string[]) => Promise<void>,
}

export interface ISignature {
  canvas: string,
  signatureId: string | null,
  url?: string,
  source?: string,
}

const SignatureModal: React.FC<Props> = ({ onClose, isOpen, createOrUpdateDraft }) => {
  let sigPad: SignaturePad;
  const dispatch = useDispatch();

  const signature = useSelector((state: RootState) => state.createService.signature);
  const loadingSignature = useSelector((state: RootState) => state.createService.loadingSignature);

  const createSignature = async (signature: ISignature | null) => {
    return dispatch(actions.createServiceAddSignature(signature));
  }

  useEffect(() => {
    if (isOpen) {
      const isAlreadySigned = signature.canvas !== "";
      sigPad.clear();

      if (isAlreadySigned) sigPad.fromDataURL(signature.canvas);
    }
  }, [isOpen]);

  const setSignature = async () => {

    const dataUrl = sigPad.getCanvas().toDataURL("image/png");

    let signature: ISignature | null = !sigPad.isEmpty() ? { canvas: dataUrl, signatureId: "" } : null;

    const res: any = await createSignature(signature);

    if (res.status === "success") {
      onClose();
      await createOrUpdateDraft([res.signatureId]);
    };

  };

  return (
    <Box sx={{ p: 2 }}>
      {/* {loadingSignature &&
        <Box sx={{
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          height: '100%',
          top: '-5px',
          opacity: '1',
          zIndex: 2,
        }}>
          <CircularProgress />
        </Box>
      } */}
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: '1px solid #eee',
      }}>
        <Typography variant="h6">Assinatura</Typography>
      </Box>
      <Divider sx={{ p: 1 }} />
      <Box
        sx={{
          width: "100%",
          height: 220,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          alignContent: "center",
          background: "#F7F6F9",
          opacity: loadingSignature ? '0.3' : '1'
        }}
      >
        <SignaturePad canvasProps={{ width: 1000, height: 220 }} ref={(ref: SignaturePad) => { sigPad = ref }} />
      </Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
        <Button onClick={() => onClose()} variant="outlined">Cancelar</Button>
        <Box sx={{ display: "flex", gap: 2 }}>
          <Button onClick={() => sigPad.clear()} variant="outlined"><Block /> Limpar</Button>
          <LoadingButton loading={loadingSignature} variant="outlined" onClick={setSignature}><Save /> Salvar</LoadingButton>
        </Box>
      </Box>
    </Box>
  );
};

export default SignatureModal;
